<div class="small-container-white">  
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
            <table class="table table--type-tight">
              <thead>
                <tr class="table__header-row">
                  <th class="table__header-cell">Application Name</th>
                  <th class="table__header-cell">Description</th>
                  <th class="table__header-cell">Risk</th>
                  <th class="table__header-cell">Business Relevance</th>
                  <th class="table__header-cell">Tags</th>
                  <th class="table__header-cell">Categories</th>                  
                  <th class="table__header-cell">Web Application</th>
                  <th class="table__header-cell">URL</th>
                  <th class="table__header-cell"></th>
               </tr>
             </thead>
             <tbody>
               <tr  class="table__row" *ngFor="let app of customeDetectorApplicationList;  let index=index">
                  <!-- <td ><label class="label">Application Name</label>
                        <input  [ngModel]="app.appName1" #appName="ngModel"/> 
                    </td> -->
                    <td class="table__cell">{{app.new_custome_detector_name}}</td>
                    <td class="table__cell">{{app.appDescription}}</td>
                    <td class="table__cell"><p>{{getRiskLevel(app.riskIndex) }}</p></td>
                    <td class="table__cell"> <p >{{getRiskLevel(app.productivityIndex) }}</p></td>
                    <td class="table__cell"> <p>{{ app.tags}}</p></td>
                    <td class="table__cell"> <p>{{ app.category }}</p></td>
                    <td class="table__cell"> <p>{{ app.web_app }}</p></td>
                    <td class="table__cell"> <p>{{ app.url }}</p></td>
                    <td class="table__cell"><button class="btn btn--primary" *ngIf="!app.appNameFind" (click)="openUpdateDetails(index)">Update Details</button></td>
               </tr>
             </tbody>
            </table>
       </div>
    </div>
  </div>
</div>



<div id="newAppDetails" class="modal modal--size-small">
  <div class="modal__dialog centerfeedback">
      <div class="modal__content">
          <div class="modal__header">
              <div class="modal__title">Set New Application Details</div>
             <a class="modal__close" (click)="closeModal('newAppDetails')"><span class="icon-close"></span></a>  
          </div>
          <div class="modal__body">              
              <!-- <label class="label">Application Name</label>
                <input type="text" class="input" formControlName="userEmail" name="userEmail"
                    placeholder="Email" > -->  

                 <label class="label">Description</label>
                <input type="text" class="input"  name="updatedDescription"
                [(ngModel)]="updatedDescription"  placeholder="Description" >    
                    
                <label class="label">Risk</label>
                <div class="select" style="margin-bottom:0px !important">
                  <select #risk1  class="select__native-select" (change)="onRiskSelected(risk1.value)">
                    <option default [value]=1>Very Low</option>
                    <option [value]=2>Low</option>
                    <option [value]=3>Medium</option>
                    <option [value]=4>High</option>
                    <option [value]=5>Very High</option>
                  </select>
                      <div class="accordion__card accordion__card--state-collapsed"></div>                  
                      <span class="select__open-icon icon icon-chevron-down"></span>
                 </div>   
                    
                     <label class="label">Business Relevance</label>
                     <div class="select" style="margin-bottom:0px !important">
                      <select #busniessRelevence class="select__native-select" (change)="onBusniessRelevenceSelected(busniessRelevence.value)">
                        <option default [value]=1>Very Low</option>
                        <option [value]=2>Low</option>
                        <option [value]=3>Medium</option>
                        <option [value]=4>High</option>
                        <option [value]=5>Very High</option>
                      </select>
                          <div class="accordion__card accordion__card--state-collapsed"></div>                  
                          <span class="select__open-icon icon icon-chevron-down"></span>
                     </div>      

                      <label class="label">Tags</label>
                <input type="text" class="input"  name="updatedTags"
                [(ngModel)]="updatedTags"  placeholder="Tags" >   
                    
                     <label class="label">Categories</label>
                <input type="text" class="input"  name="updatedCategories"
                [(ngModel)]="updatedCategories"    placeholder="Email" > 
          </div>
          <div class="modal__footer">
            <button class="btn btn--tertiary" (click)="closeModal('newAppDetails')">Cancel</button>
              <button class="btn btn--primary"  (click)="updateDetails()">Submit</button>
          </div>
      </div>
  </div>
</div>
